export function isMouseOnVerticies(visualisation, drawingLibrary, shape) {
  for (let j = 0; j < shape.length; j++) {
    let vertex = shape[j];
    let distance = drawingLibrary.dist(
      visualisation.mouseX(),
      visualisation.mouseY(),
      vertex.x,
      vertex.y
    );
    if (distance < 10) {
      return j;
    }
  }
  return -1;
}
